<div class="form-group">
  <small *ngIf="label">{{label}}</small>
  <div class="input-group">
    <ng-container *ngIf="controlName">
      <input [readonly]="isDisabled"
             [ngClass]="{'form-control form-control-sm': true , 'bg-red': isValidationError, 'form-control-inline' : inlineControl}"
             placeholder={{placeholder}}
             [(ngModel)]="model[bindValue]"
             (ngModelChange)="ModelChange()"
             [required]="isRequired"
             [minLength]="minLength"
             [maxLength]="maxLength"
             [formControl]="controlName"
             (keyup.enter)="onKeyUp()">
    </ng-container>

    <ng-container *ngIf="!controlName">
      <input [readonly]="isDisabled"
             [ngClass]="{'form-control form-control-sm': true , 'bg-red': isValidationError, 'form-control-inline' : inlineControl}"
             placeholder={{placeholder}}
             [(ngModel)]="model[bindValue]"
             (ngModelChange)="ModelChange()"
             [required]="isRequired"
             [minLength]="minLength"
             [maxLength]="maxLength"
             (keyup.enter)="onKeyUp()">
    </ng-container>
    <span *ngIf="!isDisabled" class="input-group-prepend cursor-pointer" (click)="onClear();"><span class="input-group-text" style="padding-left:6px;padding-right:6px;"><i class="fa fa-times"></i></span></span>
  </div>

    <small *ngIf="!inlineControl && isRequired" class="text-muted validator-information">Pole wymagane</small>
    <small *ngIf="!inlineControl && minLength && maxLength && minLength!==maxLength" class="text-muted validator-information"> Długość min: {{minLength}} / max: {{maxLength}}</small>
    <small *ngIf="!inlineControl && minLength && maxLength && minLength===maxLength" class="text-muted validator-information"> Długość: {{minLength}}</small>
    <small *ngIf="!inlineControl && minLength && !maxLength " class="text-muted validator-information"> Minimalna długość: {{minLength}}</small>
    <small *ngIf="!inlineControl && !minLength && maxLength && maxLength !== 1024 " class="text-muted validator-information"> Maksymalna długość: {{maxLength}}</small>
</div>
